export default "__VITE_ASSET__5c9b1e01__"